<template>
  <div class="p-3 p-md-4 text-left bg-white">
    <h1 class="mb-5">
      Settings
    </h1>
    <!-- EMAIL -->
    <div class="row d-flex mb-5">
      <div class="col-md-3 border-right flex-stretch">
        <h4>Email Address</h4>
      </div>
      <div class="col-md-9 flex-stretch">{{ user.email }}</div>
    </div>
    <!-- FAVOURITE IMAGES -->
    <div v-if="metadata" class="row d-flex mb-5">
      <div class="col-md-3 border-right flex-stretch">
        <h4>Favourite Images</h4>
      </div>
      <div class="col-md-9 flex-stretch">
        <div v-if="metadata.favouriteImages.length" class="row">
          <div
            v-for="image in metadata.favouriteImages"
            :key="image.id"
            class="d-flex col-6 col-sm-4 col-md-3"
            @click="
              image.id === background.id
                ? fetchBackgroundImage()
                : mutate({ property: 'backgroundImage', with: image })
            "
          >
            <div
              class="p-2 mb-3 "
              :class="
                image.id === background.id ? 'bg-dark-blue' : 'bg-light-grey '
              "
            >
              <img
                :src="image.urls.thumb"
                alt="Background Image"
                class="thumb"
              />
            </div>
          </div>
        </div>
        <div v-else>You have no favourite images yet</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters({
      metadata: "getMetadata",
      user: "getUser",
      background: "getBackgroundImage"
    })
  },
  methods: {
    ...mapActions({
      fetchBackgroundImage: "fetchBackgroundImage"
    }),
    ...mapMutations({
      mutate: "mutate"
    })
  }
};
</script>

<style lang="scss" scoped>
.thumb {
  width: 100%;
  height: 100px;
  object-fit: cover;
}
</style>
